var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Medium"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M20 0V20H0L0 0L20 0ZM7.24413 4.51282H3.34885V4.73857L4.60337 6.24984C4.72652 6.36084 4.78942 6.52386 4.77273 6.6888V12.6273C4.80927 12.8415 4.74174 13.0603 4.59082 13.2167L3.17949 14.9287V15.1544H7.1814V14.9287L5.77007 13.2167C5.61804 13.0606 5.54633 12.8432 5.57562 12.6273V7.49146L9.08827 15.1544H9.49599L12.5131 7.49146L12.5131 13.6346C12.5125 13.7676 12.5049 13.8018 12.4065 13.9002L11.3213 14.9537V15.1795H16.5903V14.9537L15.5428 13.9253C15.4503 13.8548 15.4044 13.739 15.4236 13.6243V6.06798C15.4044 5.95332 15.4503 5.83747 15.5428 5.76698L16.6154 4.73857V4.51282H12.902L10.255 11.116L7.24413 4.51282Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedumIcon);
export default __webpack_public_path__ + "static/media/medum_icon.da2bc0bedd47a70f48a2e039b5dcbafd.svg";
export { ForwardRef as ReactComponent };